import React, { useState, useEffect } from "react";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import {
  AddSchedulingEstimateAction,
  getSchedulingCalendar,
  getViewRequestAction,
  resetCalendarData,
  resetRequestView,
  resetSchedulingError,
  resetSchedulingMessage,
  resetSchedulingStatusCode,
  resetSchedulingSuccess,
  updateRequestAction,
} from "../../../redux/scheduling";
import JobSummery from "../../../components/Scheduling/viewPages/JobSummery";
import {
  CommonHeader,
  ContentArea,
  ErrorSuccessModal,
  Loader,
} from "../../../components/commons";
import ActionRequest from "../../../components/Scheduling/viewPages/ActionRequest";
import EmployeeSchedule from "./EmployeeSchedule";
import Calander from "../../../components/Scheduling/viewPages/Calander";
import { resetSession } from "../../../redux/auth";
import { useLocation, useParams } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";

type AppProps = {
  history: any;
  token: any;
  dispatchViewRequestData: (data: any) => void;
  requestView: any;
  fetching: boolean;
  message: string | null;
  error: string | null;
  statusCode: number | null;
  success: number | null;
  dispatchResetSession: () => void;
  dispatchResetSchedulingError: () => void;
  dispatchResetSchedulingSuccess: () => void;
  dispatchResetSchedulingMessage: () => void;
  dispatchResetSchedulingStatusCode: () => void;
  dispatchUpdateRequestAction: (data: any) => void;
  dispatchgetSchedulingCalendar: (data: any) => void;
  calendarData: any;
  dispatchResetRequestView: () => void;
  dispatchAddSchedulingEstimateAction: (data: any) => void;
  dispatchResetCalendarData: () => void;
};
const RequestView = ({
  history,
  token,
  dispatchViewRequestData,
  requestView,
  fetching,
  message,
  error,
  statusCode,
  success,
  dispatchResetSession,
  dispatchResetSchedulingError,
  dispatchResetSchedulingSuccess,
  dispatchResetSchedulingMessage,
  dispatchResetSchedulingStatusCode,
  dispatchUpdateRequestAction,
  dispatchgetSchedulingCalendar,
  calendarData,
  dispatchResetRequestView,
  dispatchAddSchedulingEstimateAction,
  dispatchResetCalendarData,
}: AppProps) => {
  const getUrl = useLocation();
  const search = useLocation().search;
  const redirectTab = new URLSearchParams(search).get("activeTab");
  const redirectNotificationId = new URLSearchParams(search).get(
    "notification_id"
  );
  let { scheduling_id }: any = useParams();
  const reDirectRequestId = scheduling_id;
  
  const requestId =
    history &&
      history?.location &&
      history?.location?.state &&
      history?.location?.state?.id
      ? history?.location?.state?.id
      : 0;

  const [getAction, setGetAction] = useState("");

  useEffect(() => {
    dispatchResetCalendarData();
    dispatchResetSchedulingError();
    dispatchResetSchedulingSuccess();
    dispatchResetSchedulingMessage();
    dispatchResetSchedulingStatusCode();
    dispatchResetRequestView();
  }, []);

  useEffect(() => {
    dispatchResetRequestView();
    if (token && (requestId || (reDirectRequestId && redirectTab))) {
      const finalPayload = {
        id: reDirectRequestId && redirectTab ? reDirectRequestId : requestId,
        isPageSeen: reDirectRequestId && redirectTab ? true : false,
        redirectNotificationId,
        token,
      };
      dispatchViewRequestData(finalPayload);
    }
  }, [history?.location?.state?.id, redirectTab, reDirectRequestId]);

  // useEffect(() => {
  //       dispatchResetRequestView()
  //   if (reDirectRequestId&&redirectTab) {
  //     const finalPayload = {
  //       id:reDirectRequestId,
  //       token,
  //     };
  //     dispatchViewRequestData(finalPayload);
  //   }
  // }, [redirectTab,reDirectRequestId]);

  const handleupdateAction = (data: any, action: string) => {
    if (action === "reject") {
      let finalData = {
        token,
        request_id: data,
        schedule_status: 2,
      };
      dispatchUpdateRequestAction(finalData);
    } else if (action === "approved") {
      let finalData = {
        token,
        request_id: data,
        schedule_status: 3,
      };
      dispatchUpdateRequestAction(finalData);
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (
        !!error &&
        statusCode !== 401 &&
        error === "Scheduling request with this id not found"
      ) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={"This request is not Authorized"}
            buttonText="OK"
            onPress={() => {
              history.push({
                pathname: `/scheduling/manager`,
              });
              dispatchResetSchedulingError();
              dispatchResetSchedulingSuccess();
              dispatchResetSchedulingMessage();
            }}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetSchedulingError();
              dispatchResetSchedulingSuccess();
              dispatchResetSchedulingMessage();
            }}
          />
        );
      }
    } else if (message === "Scheduling request fetched successfully!") {
      dispatchResetSchedulingMessage();
      let finaData = {
        token,
        user_id: requestView?.created_by?.user_id,
      };

      dispatchgetSchedulingCalendar(finaData);
    } else if (
      message ===
      "Scheduling request and estimates have been updated successfully!"
    ) {
      dispatchResetSchedulingError();
      dispatchResetSchedulingSuccess();
      dispatchResetSchedulingMessage();
      // dispatchResetRequestView()
      let finalData = {
        token,
        request_id: requestView?._id,
        schedule_status: 3,
      };
      dispatchUpdateRequestAction(finalData);
    } else if (
      message === "Estimation request has been approved successfully" &&
      getAction !== "update"
    ) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={"Request Approved Successfully"}
          buttonText="OK"
          onPress={() => {
            dispatchResetSchedulingError();
            dispatchResetSchedulingSuccess();
            dispatchResetSchedulingMessage();
            history.push({
              pathname: `/scheduling/manager`,
            });
          }}
        />
      );
    } else if (
      message === "Estimation request has been approved successfully" &&
      getAction === "update"
    ) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={"Request Updated And Approved Successfully"}
          buttonText="OK"
          onPress={() => {
            dispatchResetSchedulingError();
            dispatchResetSchedulingSuccess();
            dispatchResetSchedulingMessage();
            history.push({
              pathname: `/scheduling/manager`,
            });
          }}
        />
      );
    } else if (message == "Estimation request has been rejected successfully") {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={"Request Rejected Successfully"}
          buttonText="OK"
          onPress={() => {
            dispatchResetSchedulingError();
            dispatchResetSchedulingSuccess();
            dispatchResetSchedulingMessage();
            history.push({
              pathname: `/scheduling/manager`,
            });
          }}
        />
      );
    }

    return false;
  };

  return (
    <>
      <div className="col-md-6">
        <CommonHeader title="View Request" />
      </div>
      <ContentArea>
        {!fetching ? (
          <JobSummery
            header={[
              "jobIdType",
              "description",
              "client",
              "startDate",
              "targetEndDate",
              "estimatedHour",
              "CurrentlyResposible",
            ]}
            data={requestView}
          />
        ) : (
          ""
        )}

        <div className="mt-3">
          <ActionRequest
            data={requestView}
            success={success}
            handleupdateAction={handleupdateAction}
            history={history}
            token={token}
            dispatchAddSchedulingEstimateAction={
              dispatchAddSchedulingEstimateAction
            }
            getAction={getAction}
            setGetAction={setGetAction}
          />
        </div>

        <Calander
          data={requestView}
          approvedData={calendarData}
          redirectTab={redirectTab}
          reDirectRequestId={reDirectRequestId}
        />
      </ContentArea>
      <Toaster />
      {handleErrorModal()}
      {fetching && <Loader />}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  requestView: state.scheduling.requestView,
  fetching: state.scheduling.fetching,
  message: state.scheduling.message,
  error: state.scheduling.error,
  statusCode: state.scheduling.statusCode,
  success: state.scheduling.success,
  calendarData: state.scheduling.calendarData,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchViewRequestData: (data: any) => dispatch(getViewRequestAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetSchedulingError: () => dispatch(resetSchedulingError()),
  dispatchResetSchedulingSuccess: () => dispatch(resetSchedulingSuccess()),
  dispatchResetSchedulingMessage: () => dispatch(resetSchedulingMessage()),
  dispatchResetSchedulingStatusCode: () =>
    dispatch(resetSchedulingStatusCode()),
  dispatchUpdateRequestAction: (data: any) =>
    dispatch(updateRequestAction(data)),
  dispatchgetSchedulingCalendar: (data: any) =>
    dispatch(getSchedulingCalendar(data)),
  dispatchResetRequestView: () => dispatch(resetRequestView()),
  dispatchAddSchedulingEstimateAction: (data: any) =>
    dispatch(AddSchedulingEstimateAction(data)),
  dispatchResetCalendarData: () => dispatch(resetCalendarData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RequestView);
